import {
  SET_USER,
  SET_ERRORS,
  CLEAR_ERRORS,
  LOADING_UI,
  LOADER_FALSE,
  LOADER_CHECK,
  TICKET_LIST,
} from "../type";
import axios from "axios";
import { toast } from "react-toastify";
import { TicktingList } from "../../Component/Helpers/api";
import $ from "jquery";
import { dataLocation } from '../../Component/Helpers/util';
import axiosInstance from "../../utils/axiosInstance";
const userDataLocal1 = dataLocation();

var LocationObj = JSON.parse(userDataLocal1);

export const TickList = (pageDetail) => async (dispatch) => {
  dispatch({ type: LOADING_UI });

  try {
    // Make the POST request using the Axios instance
    const res = await axiosInstance.post(`${process.env.REACT_APP_API_GATEWAYS_URL}cspoc/api/v2/tickets/ticketListV3`, pageDetail);

    // Check the response status
    if (res.status === 200) {
      dispatch({ type: TICKET_LIST, payload: res.data });
      dispatch({ type: CLEAR_ERRORS });
      dispatch({ type: LOADER_CHECK });
      $(".close").click(); // Close the modal if needed
    } else {
      dispatch({ type: CLEAR_ERRORS });
      toast.error(res.data.message, {

      });
    }
  } catch (error) {
    dispatch({ type: CLEAR_ERRORS });
  
    // You could optionally log or handle the error more gracefully
  }
};

export const CheckLoader = () => (dispatch) => {
  dispatch({ type: LOADER_FALSE });
};
